<template>
  <parallax sectionClass="Masthead main" :sectionHeight="30">
    <navigation />
    <b-container class="header-position">
      <b-row>
        <b-col style="position: relative" lg="6">
          <h1 class="image-header">Ferienhausvermietung Wolfgang Weber</h1>
        </b-col>
      </b-row>
    </b-container>
    <img src="https://ferienhaus.webdev-jogeleit.de/images/weber_front.jpg" />
  </parallax>
</template>

<script>
import Parallax from 'vue-parallaxy'
import Navigation from '@/components/Navigation'

export default {
  name: 'header-small',
  components: {
    Navigation,
    Parallax
  }
}
</script>

<style scoped>
  body .Masthead.main,
  body .Masthead.second {
    z-index: 99;
  }

  .header-position {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
  }

  @media screen and (min-width: 768px) {
    body .Masthead.main {
      min-height: 200px;
    }
  }

  @media screen and (max-width: 767px) {
    body .image-header {
      font-size: 1.7rem;
    }

    body .header-position {
      top: 100px
    }
  }
</style>
